import "./styles.css";

import { Text } from "@fragments";

export default function AnimatedText({ text, component = "span", ...props }) {
    const tagMap = {
        "h1": "h1",
        "h2": "h2",
        "h3": "h3",
        "h4": "h4",
        "h5": "h5",
        "h6": "h6",
        "p": "p",
        "div": "div",
        "span": "span"
    };

    const Tag = Text[component] || "span";

    return (
        <Tag {...props}>
            {text.split("").map((char, index) => (
                <span
                    key={index}
                    className="animated-char"
                    style={{ animationDelay: `${index * 0.05}s` }}
                >
                    {char}
                </span>
            ))}
        </Tag>
    );
}
